"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useForkRef = useForkRef;
var _react = require("react");
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/**
 * Combines 1+ refs (functional or refobject) into a single functional ref.
 * Make sure you memoize the refs if they are callback functions or you'll get extra renders!
 */
function useForkRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return (0, _react.useMemo)(() => {
    if (refs.every(ref => !ref)) {
      return null;
    }
    return refValue => {
      refs.forEach(r => setRef(r, refValue));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}
//# sourceMappingURL=useForkRef.js.map